// src/components/NAV.jsx

import React, {useEffect, useState} from "react";
import oa_logo from "../img/OA_logo.jpg";
import StockSearch from "../components/search";
import TopBar from "./topbar";

function NAV({ activetag = "home" }) {

  const [mobileMenu, setMobileMenu] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const navLink = (tag) => {

    const active = activetag === tag;

    if (scrolled) {

      return active
        ? "text-green-700 font-semibold"
        : "text-gray-700 hover:text-green-700 transition";

    }

    return active
      ? "text-white font-semibold"
      : "text-white/80 hover:text-white transition";

  };


    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {

      const handleScroll = () => {

        setScrolled(window.scrollY > 40);

      };

      window.addEventListener("scroll", handleScroll);

      return () =>
        window.removeEventListener("scroll", handleScroll);

    }, []);

  return (
      <div
        className="
          fixed
          top-0
          left-0
          w-full
          z-50
        "
      >
      <TopBar />

      <nav
        className={`

          w-full
          z-50
          transition-all
          duration-300
      
          ${
            scrolled
              ? "bg-gray-50 shadow-lg backdrop-blur-md"
              : "bg-transparent"
          }
        `}
      >

      <div
        className="
          w-full
          px-4
          lg:px-10
        "
      >

        <div
          className="
            flex
            items-center
            justify-between
            h-24
          "
        >

          {/* =========================
              LEFT LOGO
          ========================= */}

          <a
            href="/"
            className="flex items-center gap-4 flex-shrink-0"
          >

            <img
              src={oa_logo}
              alt="Orion Analytics"
              className="
                h-16
                w-16
                rounded-2xl
                object-cover
              "
            />

            <div>

              <div
                className={`
                  text-2xl
                  font-extrabold
                  tracking-tight
                
                  ${scrolled ? "text-green-800" : "text-white"}
                `}
              >
                Orion Analytics
              </div>

              <div
                className={`
                  text-sm
                  text-white/70
                "
                ${scrolled ? "text-black-50" : "text-white/70"}
                `}
              >
                Financial Intelligence Platform
              </div>

            </div>

          </a>

          {/* =========================
              SEARCH
          ========================= */}

          {
            activetag !== "login" && (

              <div
                className="
                  hidden
                  xl:block
                  w-[320px]
                  mx-8
                "
              >
                <StockSearch />
              </div>

            )
          }

          {/* =========================
              DESKTOP MENU
          ========================= */}

          {
            activetag !== "login" && (

              <div
                className="
                  hidden
                  lg:flex
                  items-center
                  gap-8
                "
              >

                <a href="/" className={navLink("home")}>
                  Home
                </a>

                <a href="/news" className={navLink("news")}>
                  News
                </a>

                <a href="/marketpage" className={navLink("marketpage")}>
                  Markets
                </a>

                <a href="/stock/" className={navLink("stock")}>
                  Stocks
                </a>

                <a href="/mf/" className={navLink("mf")}>
                  Mutual Funds
                </a>

                {/* =========================
                    SERVICES DROPDOWN
                ========================= */}

                <div
                  className="relative"
                  onMouseEnter={() => setServicesOpen(true)}
                  onMouseLeave={() => setServicesOpen(false)}
                >

                  <button
                    className={`
                      flex
                      items-center
                      gap-1
                      ${navLink("service")}
                    `}
                  >

                    Services

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>

                  </button>

                  {
                    servicesOpen && (

                      <div
                        className="
                          absolute
                          top-10
                          left-0
                          w-72
                          bg-white
                          rounded-2xl
                          shadow-2xl
                          border
                          border-gray-100
                          p-3
                          space-y-1
                        "
                      >

                        <a
                          href="/ia/"
                          className="
                            block
                            px-4
                            py-3
                            rounded-xl
                            hover:bg-green-50
                            transition
                          "
                        >
                          Investment Advisory
                        </a>

                        <a
                          href="/portfolio/"
                          className="
                            block
                            px-4
                            py-3
                            rounded-xl
                            hover:bg-green-50
                            transition
                          "
                        >
                          Portfolio
                        </a>

                        <a
                          href="/ra/"
                          className="
                            block
                            px-4
                            py-3
                            rounded-xl
                            hover:bg-green-50
                            transition
                          "
                        >
                          Risk Analytics
                        </a>

                        <a
                          href="/tbd"
                          className="
                            block
                            px-4
                            py-3
                            rounded-xl
                            hover:bg-green-50
                            transition
                          "
                        >
                          Software
                        </a>

                        <a
                          href="/tbd"
                          className="
                            block
                            px-4
                            py-3
                            rounded-xl
                            hover:bg-green-50
                            transition
                          "
                        >
                          Data Services
                        </a>

                      </div>

                    )
                  }

                </div>

                <a href="/blog" className={navLink("blog")}>
                  Blogs
                </a>

                <a href="/about" className={navLink("about")}>
                  About
                </a>

                <a href="/contact" className={navLink("contact")}>
                  Contact
                </a>

                {/* =========================
                    CTA BUTTON
                ========================= */}

                <a
                  href="/#target_section"
                  className="
                    bg-green-500
                    text-green-800
                    hover:bg-green-50
                    text-white
                    px-6
                    py-3
                    rounded-2xl
                    font-semibold
                    shadow-md
                    transition
                  "
                >
                  Get Started
                </a>

              </div>

            )
          }

          {/* =========================
              MOBILE MENU BUTTON
          ========================= */}

          <button
            className="
              lg:hidden
              p-2
              rounded-xl
              hover:bg-gray-100
            "
            onClick={() => setMobileMenu(!mobileMenu)}
          >

            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-7 w-7"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >

              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />

            </svg>

          </button>

        </div>

      </div>

      {/* =========================
          MOBILE MENU
      ========================= */}

      {
        mobileMenu && (

          <div
            className="
              lg:hidden
              border-t
              border-gray-100
              bg-white
              px-6
              py-6
              space-y-5
            "
          >

            <a href="/" className="block text-gray-700">
              Home
            </a>

            <a href="/news" className="block text-gray-700">
              News
            </a>

            <a href="/marketpage" className="block text-gray-700">
              Markets
            </a>

            <a href="/stock/" className="block text-gray-700">
              Stocks
            </a>

            <a href="/mf/" className="block text-gray-700">
              Mutual Funds
            </a>

            <a href="/service/" className="block text-gray-700">
              Services
            </a>

            <a href="/blog" className="block text-gray-700">
              Blogs
            </a>

            <a href="/about" className="block text-gray-700">
              About
            </a>

            <a href="/contact" className="block text-gray-700">
              Contact
            </a>

            <a
              href="/#target_section"
              className="
                block
                text-center
                bg-green-700
                text-white
                py-4
                rounded-2xl
                font-semibold
              "
            >
              Get Started
            </a>

          </div>

        )
      }

    </nav>
      </div>
  );

}

export default NAV;